import { render } from "./Seikyusyocreate.vue?vue&type=template&id=23a51bb8&scoped=true&ts=true"
import script from "./Seikyusyocreate.vue?vue&type=script&lang=ts"
export * from "./Seikyusyocreate.vue?vue&type=script&lang=ts"

import "./Seikyusyocreate.vue?vue&type=style&index=0&id=23a51bb8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a51bb8"]])

export default __exports__